import { FC } from "react";
import { useSelector } from "react-redux";

import { eventBlockSelectorCreator } from "Bands/state";
import { EventBlocks, IEventInfoBlock } from "Bands/types";
import { InfoBlockItems, RTEContent } from "shared/components";
import { useInfoBlockItemsProps } from "shared/utils";
import { NotFlexSpacer } from "../EventSchedule/styles";

interface EventInfoBlockProps {
  blockId: string;
}

export const EventInfoBlock: FC<EventInfoBlockProps> = ({ blockId }) => {
  const infoBlockSelector = eventBlockSelectorCreator(
    blockId,
    EventBlocks.infoBlock
  );

  const infoBlock = useSelector(infoBlockSelector) as IEventInfoBlock;

  const itemsProps = useInfoBlockItemsProps(
    {
      places: infoBlock.places || [],
      contacts: infoBlock.contacts || [],
      files: infoBlock.files || [],
      images: infoBlock.images || [],
    },
    "view"
  );

  return (
    <NotFlexSpacer size="l">
      <RTEContent content={infoBlock.text} />
      {itemsProps.map(
        ({ items, type, ...rest }) =>
          !!items?.length && (
            <InfoBlockItems
              items={items}
              key={`${infoBlock.id}_${type}`}
              type={type}
              {...rest}
            />
          )
      )}
    </NotFlexSpacer>
  );
};
